import React, { useContext } from 'react';
import { getConfiguration } from '../utils/configuration';
import { SeoContext } from './SeoContextProvider';
import { useHandleSeoMetas } from './seoUtils';


function SeoMetaTags(props) {
    const cfgSeo = getConfiguration().seo;
    const seoContext = useContext(SeoContext);
    useHandleSeoMetas(seoContext.pathname,seoContext.location,'seo-main-container');

    return (
        <></>
    );
}

export default SeoMetaTags;